export const InfoIcon = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16">
		<path
			fill="#5390E9"
			d="M8 1C4.1344 1 1 4.1344 1 8s3.1344 7 7 7 7-3.1344 7-7-3.1344-7-7-7Zm.5 10.375a.1254.1254 0 0 1-.125.125h-.75a.1254.1254 0 0 1-.125-.125v-4.25c0-.0687.0563-.125.125-.125h.75c.0687 0 .125.0563.125.125v4.25ZM8 6c-.414 0-.75-.336-.75-.75s.336-.75.75-.75.75.336.75.75S8.414 6 8 6Z"
		/>
	</svg>
);
